// let spotId = 0;
let selectedSpot;

function HotSpot(settings) {
  this.parent = settings.image;
  this.id = settings.spotId;
  this.x = settings.x;
  this.y = settings.y;
  this.layoutId = settings.layoutId;
  let div = document.createElement('div');
  div.classList.add('t_hotSpot')
  div.setAttribute('id', `t_hotspot_${this.layoutId}_${this.id}`)
  let childDiv = document.createElement('div');
  childDiv.classList.add('t_tooltip_content_wrap');
  let grandChild_1 = document.createElement('div');
  grandChild_1.classList.add('t_tooltip_content');
  let grandChild_2 = document.createElement('div');
  grandChild_2.classList.add('arrow');
  let grandChild_3 = document.createElement('div');
  grandChild_3.classList.add('site_value');
  childDiv.appendChild(grandChild_2);
  childDiv.appendChild(grandChild_1);
  childDiv.appendChild(grandChild_3);
  div.appendChild(childDiv);

  this.html = div;
  this.root = '';

  this.settings = {
    "t_spotType": "circle",
    "t_spotSize": "small",
    "t_spotColor": settings.pointerColor,
    "t_spotColorOpacity": settings.transparency,
    "t_popupPosition": settings.tooltipPosition,
    "t_toolTipVisible": true,
    "t_content": settings.label,
    "t_contentColor": settings.labelColor,
    "t_contentValue": settings.value,
    "t_toolTipBackgroundColor": settings.backGroundColor,
    "t_toolTipBorderColor": settings.borderColor,
    // "t_toolTipWidthAuto": true
  };

}

HotSpot.prototype.init = function () {
  this.parent.append(this.html);
  // this.root = $('#'+this.layoutId).find('#t_hotspot_'+this.layoutId +'_'+ this.id);
  this.root = $('#t_hotspot_' + this.layoutId + '_' + this.id);
  this.root.css({
    "left": this.x + '%',
    "top": this.y + '%'
  });
  this.applySettings();
};

HotSpot.prototype.select = function () {
  $('.t_hotSpot.selected').removeClass('selected');
  this.root.addClass('selected')
  this.root.find('.t_tooltip_content_wrap').css({
    opacity: 1
  });
  selectedSpot = this;
};

HotSpot.prototype.deselect = function (value = {}) {
  $('.t_hotSpot.selected').removeClass('selected');
  this.root.find('.t_tooltip_content_wrap').css("opacity", "");
  if (selectedSpot && value) {
    selectedSpot.settings['t_content'] = value.label;
    selectedSpot.settings['t_toolTipBackgroundColor'] = value.backGroundColor;
    selectedSpot.settings['t_toolTipBorderColor'] = value.borderColor;
    selectedSpot.applySettings();
  }
  selectedSpot = null;
};

HotSpot.prototype.delete = function () {
  this.deselect();
  this.root.remove();

  // hotSpots[this.id] = null;
};

HotSpot.prototype.applySettings = function () {
  this.root.removeClass('circle').removeClass('square').removeClass('circleOutline').removeClass('squareOutline').removeClass('small').removeClass('medium').removeClass('large').removeClass('red').removeClass('green').removeClass('blue').removeClass('purple').removeClass('pink').removeClass('orange');
  var wrap = this.root.find('.t_tooltip_content_wrap');

  wrap.removeClass('top').removeClass('left').removeClass('bottom').removeClass('right');
  this.root.addClass(this.settings['t_spotType']);
  this.root.addClass(this.settings['t_spotSize']);
  this.root.css('background', hexToRgbA(this.settings['t_spotColor'], this.settings['t_spotColorOpacity']));
  wrap.addClass(this.settings['t_popupPosition']);
  wrap.find('.t_tooltip_content').html(this.settings['t_content']).css('color', this.settings['t_contentColor']);
  wrap.find('.site_value').html(this.settings['t_contentValue']).css('color', this.settings['t_contentColor']);
  wrap.find('.t_tooltip_content').parent().css('background', this.settings['t_toolTipBackgroundColor']);
  wrap.find('.t_tooltip_content').parent().css('border-color', this.settings['t_toolTipBorderColor']);
  wrap.find('.arrow').css(GetBorderProperty(this.settings['t_popupPosition']), this.settings['t_toolTipBorderColor']);
  wrap.removeClass('alwaysVisible');
  if (this.settings['t_toolTipVisible']) {
    wrap.addClass('alwaysVisible')
  }
  if (!this.settings['t_toolTipWidthAuto']) {
    wrap.css({
      'width': this.settings['t_toolTipWidth']
    }).addClass('specificWidth');
  } else {
    wrap.css({
      'width': 'auto'
    }).removeClass('specificWidth');
  }
}


function hexToRgbA(hex, opacity = 1) {
  var c;
  if (!hex.includes('#')) {
    return hex
  }
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ', ' + opacity + ')';
  }
  return hex
}

function GetBorderProperty(position) {
  if (position === 'right') {
    return 'border-right-color';
  } else if (position === 'left') {
    return 'border-left-color';
  } else if (position === 'top') {
    return 'border-top-color';
  } else if (position === 'bottom') {
    return 'border-bottom-color';
  }
}


export {
  HotSpot,
  selectedSpot
}



//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/assets/lib/jquery_hotspot.js
// module id = ../../../../../src/assets/lib/jquery_hotspot.js
// module chunks = main